import LoginModal from "./AuthenticationModal";
import BuyModal from "./BuyModal";
import LanguageSwitcherModal from "./LanguageSwitcherModal";
import RankedDetailsModal from "./RankedDetailsModal";
import RewardModal from "./RewardModal";

const Modals: React.FC = () => {
  return (
    <>
      <RankedDetailsModal />
      <BuyModal />
      <LoginModal />
      <RewardModal />
      <LanguageSwitcherModal />
    </>
  );
};

export default Modals;
